<template>
    <div :class="{'bf_wave--to-tremfya': toTremfya}" class="bf_wave">
        <svg :transform="toTremfya ? '' : 'scale(-1,1)'">
            <defs>
                <!-- Psoriasis yellow gradient -->
                <linearGradient id="PsoriasisGradientWave" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#F6BD3A" />
                    <stop offset="100%" stop-color="#F5BC39" />
                </linearGradient>
                <!-- Tremfya blue gradient -->
                <linearGradient id="TremfyaGradientWave" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#00C7C7" />
                    <stop offset="100%" stop-color="#00B2AA" />
                </linearGradient>
            </defs>

            <mask id="waveMask">
                <svg viewBox="0 0 123 768" preserveAspectRatio="none" width="6.1%" height="100%" x="0" y="0">
                    <g transform="translate(-1087.000000, 0.000000)">
                        <g transform="translate(0.000000, -91.000000)">
                            <path fill="#FFF"  d="M1087.7,91h122.8v768h-3.7c6.8-117.2-10-241.5-50.4-373.1S1093.1,222.7,1087.7,91z"/>
                        </g>
                    </g>
                </svg>
                <rect fill="#FFF" x="6%" y="0" width='94%' height='100%' />
            </mask>

            <rect
                :fill="`url(#${toTremfya ? 'TremfyaGradientWave' : 'PsoriasisGradientWave'})`"
                mask="url(#waveMask)" width='100%' height='100%' />
        </svg>
    </div>
</template>

<script>
import { TweenMax, TimelineMax, Power0 } from 'gsap';
import { mapState } from 'vuex';

TweenMax.defaultEase = Power0.easeNone;

export default {
  data() {
    return {
      toTremfya: true
    };
  },
  computed: {
    ...mapState(['userAgent'])
  },
  watch: {},
  methods: {},
  mounted() {
    let hookIndex = this.$store.state.switchWaveNavGuardIndex; // nav guard hook index

    if (hookIndex >= 0) {
      this.$router.beforeHooks.splice(hookIndex, 1); // remove old hook
    }

    this.$router.beforeEach((to, from, next) => {
      // if move from Psoriasis to Tremfya
      if (from.name.includes('Psoriasis') && to.name.includes('Tremfya')) {
        this.toTremfya = true;
        let tl = new TimelineMax({
          onStart: () => {
            this.$el.removeAttribute('style');
            this.lockScroll();
            this.$store.commit('setTransitionAnimated', true);
            document.body.classList.add('block-pointer-events');
          }
          //,
          // onComplete: () => { }
        });
        tl.fromTo(this.$el, 0.5, { left: '100%' }, { left: '-15%' })
          .call(() => {
            this.$store.commit('setTransitionAnimated', false);
            document.body.classList.remove('block-pointer-events');
            this.unlockScroll();
            next();
          })
          .fromTo(this.$el, 0.5, { opacity: 1 }, { opacity: 0 }, '+=0.5')
          .call(() => {
            this.$el.removeAttribute('style');
          });
      } else if (
        from.name.includes('Tremfya') &&
        to.name.includes('Psoriasis')
      ) {
        this.toTremfya = false;
        let tl = new TimelineMax({
          onStart: () => {
            this.lockScroll();
            this.$store.commit('setTransitionAnimated', true);
            document.body.classList.add('block-pointer-events');
          }
        });
        tl.fromTo(this.$el, 0.5, { right: '100%' }, { right: '-15%' })
          .call(() => {
            this.$store.commit('setTransitionAnimated', false);
            document.body.classList.remove('block-pointer-events');
            this.unlockScroll();
            next();
          })
          .fromTo(this.$el, 0.5, { opacity: 1 }, { opacity: 0 }, '+=0.5')
          .call(() => {
            this.$el.removeAttribute('style');
          });
      } else {
        next();
      }
    });
    this.$store.commit(
      'setSwitchWaveNavGuardIndex',
      this.$router.beforeHooks.length - 1
    );
  }
};
</script>

<style lang="scss" src="./Wave.scss">
</style>
